import { FormattedMessage } from 'react-intl';

import Loader from '~components/generic/loader/Loader';
import { UsersListItem } from './UsersListItem';
import styles from './UsergroupsList.module.css';

export type UsersListProps = {
  groupName: string;
  users?: string[];
  loading?: boolean;
};

export const UsersList = ({ users, groupName, loading }: UsersListProps) => (
  <div className={styles.list}>
    {users && users.length ? (
      users.map(user => <UsersListItem groupName={groupName} user={user} key={user} />)
    ) : (
      <div className={styles.listItem}>
        {loading ? (
          <div className={styles.cellLoader}>
            <Loader theme="dark" />
          </div>
        ) : (
          <div className={styles.cellNotification}>
            <FormattedMessage id="msgNoUsersInUsergroup" defaultMessage="msgNoUsersInUsergroup" />
          </div>
        )}
      </div>
    )}
  </div>
);
